import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import BackupWizard from './BackupWizard'
import './styles.css'

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js').catch(() => undefined))
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {window.location.pathname === '/copia' ? <BackupWizard /> : <App />}
  </StrictMode>,
)
